import Typography from '@material-ui/core/Typography';

import useStyles from './index.styles';
import CustomIcon from '../customIcons';
import { kollectAITheme } from 'config/theme';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { useState } from 'react';

export type SideMenuItemProps = {
  title: string;
  className?: string;
  onClick?: () => void;
  isActive?: boolean;
  iconName?: string;
  disabled?: boolean;
  subMenu?: Array<{ label: string; url: string }>;
};

const SideMenuItem: React.FC<SideMenuItemProps> = ({
  title,
  className,
  onClick,
  isActive,
  iconName,
  disabled,
  subMenu,
}) => {
  const classes = useStyles({ isActive });

  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      position='relative'
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <button
        className={`${classes.sideMenuItemMainCont} ${className}`}
        onClick={onClick}
        disabled={disabled}
      >
        {isActive && <div className={classes.sideMenuItemActiveBarStyle}></div>}
        <div className={classes.sideMenuIteIconContStyle}>
          <CustomIcon
            name={iconName}
            size={25}
            color={kollectAITheme.primaryColor}
            // className={classes.sideMenuItemRightIconStyle}
          />
        </div>
        <Typography className={classes.sideMenuItemRightTitleStyle}>
          {title}
        </Typography>
      </button>

      {subMenu && isHovered && (
        <Box className={classes.submenuStyle}>
          {subMenu.map((subMenu) => (
            <Link to={subMenu.url} key={subMenu.url}>
              {subMenu.label}
            </Link>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default SideMenuItem;
